import { HOST } from '../configs/'
const sendRepairToLine = (id, lineId) => {
    const token = localStorage.getItem('token');
    const fecthOption = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ lineId })
    }
    fetch(`${HOST}/webhook/send-repair-to-line/${id}`, fecthOption)
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson === 200)
                alert('Send Success')
            else
                alert('Error, please try again later')
        }).catch((error) => {
            alert('Error, please try again later')
        });
}

export { sendRepairToLine }


// WEBPACK FOOTER //
// ./src/services/line.js